<template>
  <section class="apps-entry">
    <Steps class="apps-entry-steps" direction="vertical" :current="step">
        <Step title="阅读规章制度" content="请认真阅读公司规章制度">
        </Step>
        <Step title="填写员工信息表" content="请认真填写员工信息表" @click="goToStep(1)"></Step>
        <Step title="上传资料" content="身份证、学历证、学位证"></Step>
        <Step :title="entry_info.type=='审核通过'?'已审核':'等待审核'" :content="entry_info.type=='审核通过'?'请查看审核结果':'请耐心等待'"></Step>
        <Step title="下载合同" content="下载相应的合同，填写个人信息，并签名"></Step>
    </Steps>
    <div class="apps-entry-content">
      <transition name="fade" mode="out-in">
        <div class="step-panle" v-if="step==0">
          <div class="rules-head">
            <h1 style="text-align:left">规章制度</h1>
          </div>
          <div class="rules-content">
            <div class="rules-book">
              <h4>公司介绍</h4>
              <p>• 浙江宇脉科技股份有限公司简称宇脉科技，原名浙江宇脉科技有限公司，2015年12月完成股份制改革，公司名称相应变更。</p>
              <p>• 宇脉科技于2016年7月28日在新三板挂牌。</p>
              <p>股票代码：837977</p>
              <h4>主营业务</h4>
              <p>• 移动网络规划、设计</p>
              <p>• 通信网络工程优化、设备调测</p>
              <p>• 网络维护日常优化、专项优化</p>
              <p>• 网络评估、第三方测试</p>
              <p>• 通信工程施工、监理、项目管理</p>
              <p>• 室内覆盖工程优化</p>
              <h4>组织构架</h4>
              <p>公司建立了完善的组织架构，共设12个部门：移动事业部、电信事业部、厂商合作部、西南办事处、江西办事处、新疆办事处、设计一所、设计二所、设计三所、软件开发部、综合管理部、市场营销部，为公司的有序发展及业务拓展提供了坚强的后盾。</p>
              <h4>规章制度</h4>
              <p>我们提倡诚信做人，您提供的个人信息应真实准确。同时，公司保留对您提供的个人资料进行审核的权利，如有虚假，您会被要求即时离职。</p>
              <p>资料提供后您将和公司签订劳动合同，劳动合同中如有不清楚的，可及时向人事专员询问，劳动合同签订后您就是公司的员工了，人事专员将会告知您公司规章制度查阅方式及相关事项，让您其尽快熟悉公司的规章制度。</p>
              <p>如直接到项目员工，务必于15天内签订合同寄回公司，逾期一个月未签，沟通后仍未签的，公司将视为个人拒签，公司将与个人解除聘用关系。</p>
              <Tag>试用期</Tag>
              <p>入职公司的每一位员工都有试用期，试用期一般为三个月，最长不超过六个月。公司将根据您在试用期内的表现缩短或延长试用期。</p>
              <Tag>转正</Tag>
              <p>在试用期到期前15天，综合管理部将会邮件通知您预计转正时间，您需要填写试用期工作总结及转正申请表，发送给您的直接领导和人事专员，经所在部门和公司领导考核，按照权限规定审批，最终确认转正时间，办理转正手续。转正手续办理完毕后将由综合管理部邮件通知您具体的转正时间，您就成为公司的正式员工了。</p>
              <Tag>合同期满终止劳动合同及续签</Tag>
              <p>在合同期满前一个月，公司根据工作需要会发出书面的合同续签意向表，或通知到员工是否需要继续签合同，以征询员工意见，如双方确定续签的，将在合同期满时15天内续签好合同，如不续签的，合同期满需交接好工作，办理离职手续，劳动合同即终止。</p>
              <Tag>离职</Tag>
              <p>在试用期内，如您要离职，因公司工作性质，您必须提前15天以书面形式向您的直接主管、公司领导提出，待公司领导批准后，安排相关人员进行工作交接，工作交接完后方可办理离职手续；同样，公司如需要解除劳动合同，也会提前15天书面通知您，同时告知您解除合同的原因。</p>
              <h4>工作时间</h4>
              <p>公司实行一周5天工作制。周一至周五上班，每天工作8小时，周六、周日休息：</p>
              <p>4月1号-10月31日：上班时间： 9:00   下班时间：17：30  午休时间12:00——13:30</p>
              <p>11月1日-3月31日：上班时间： 9:00   下班时间：17：00  午休时间12:00——13:00</p>
              <p>因为实际工作需要及各地区作息习惯，您出差时的作息时间由您所在的项目组规定调整。</p>
              <h4>办公管理</h4>
              <p>上班时间员工必须着装整洁，树立良好的公司形象和个人形象。</p>
              <p>办公室等公共场所严禁吸烟。严禁喧哗、嘻闹、打牌、躺卧、听音响、不准聚众闲聊，不准看与工作无关的书籍和报刊杂志，营造良好的工作环境。</p>
              <p>在上班时间不准玩游戏、看电影（电视）、炒股票，影响其他同事的网速，一经发现，进行口头警告，第二次发现，进行公司内部通报批评，第三次后每发现一次，扣除当月补助100元/次；屡次不改者，可由综合管理部发出行政处罚书，情节严重者进行劝退或辞退。</p>
              <p>不得用公司设备，传真、打印、复印与工作无关资料。</p>
              <p>爱护办公室的各项设施，随时保持办公室干净、整洁。</p>
              <p>办公室人员在工作接触中或在接听电话中要使用“您好、请、谢谢、对不起、再见”等文明用语。</p>
              <p>下班时随手整理自己的办公桌。关闭电脑、空调、传真、打印机，关窗，断电，锁门。</p>
              <p>因为实际工作需要，在项目组中的办公纪律遵照项目组规定执行。若由于个人原因引起客户投诉或扣款，造成的损失由个人承担60%，公司承担40%。</p>
              <h4>考勤休假管理</h4>
              <p>公司各部门的考勤统一接受综合管理部的管理，并由各部门主管进行检查，监督。</p>
              <p>员工应严守作息规定，不得迟到早退，不得随意离岗，更不得旷工。</p>
              <p>各项目主管应严格执行考勤制度，据实记录员工出勤情况，不得虚报、漏报。</p>
              <p>员工临时离岗，需向直接主管领导请假，在安排其他员工暂管其职责后方可离岗。否则，按擅自离岗处理。</p>
              <p>有以下行为之一者，记为旷工，旷工三日属严重违反公司规章的行为，公司有权解除劳动合同。</p>
              <p>（1）当日未到岗、未经请假；</p>
              <p>（2）未到岗而提供的证明材料经核查为虚假的；</p>
              <p>（3）到岗后擅自离岗时间累计超过1小时的。</p>
              <p>（4）未经批准擅自离开项目。</p>
              <h4>公司薪资</h4>
              <p>综合管理类员工工资由基本工资和岗位工资两部分组成；技术类员工工资由岗位工资、岗位津贴、出差补贴三部分组成。</p>
              <p>基本工资部分发放时间为次月20日，岗位工资或出差补贴部分发放时间为次月30日。发放方式为银行转账出款，如因特殊情况推迟发放的，公司将会提前以书面形式通知到员工本人，并告知具体发放时间；原则上推迟时间不超过一星期。</p>
              <Tag>$ 加班工资</Tag>
              <p>公司全体员工根据法律法规享有国家法定节假日。国家法定节假日须加班的员工，经项目组申请（加班必须填加班申请单，由客户书面或邮件确认）、综合管理部备案，享有三倍基本工资。加班工资随基本工资部分一起发放。</p>
              <Tag>$ 试用期工资</Tag>
              <p>试用期工资一般为转正后工资额的80%。</p>
              <Tag>$ 薪金调整原则</Tag>
              <p>由公司制定的员工基本工资上限指引，根据企业效益、行业社会平均水平及相关考核办法，每年进行一次调整，具体考核措施将会提前书面通知到员工本人。</p>
              <Tag>$ 个人所得税</Tag>
              <p>所有形式的工资均为税前工资，发生的所得税由员工个人承担。</p>
              <h4>公司福利</h4>
              <p>一旦您和公司签订劳动合同，您将享有公司提供的以下福利。</p>
              <Tag>社会福利</Tag>
              <p>跟据规定，公司将统一购买养老保险、工伤保险、医疗保险、失业保险、生育险等社会保险项目，保险个人应缴纳部分将由公司在当月工资中予以代扣。</p>
              <Tag>企业福利</Tag>
              <p>公司根据国家法律提供以下福利性节假日：</p>
              <p>国家法定节假日、婚假、丧假、产假、年休假等。具体休假制度请参见前面的考勤休假管理一节。</p>
              <h4>差旅费报销</h4>
              <p>经批准出差人员，应如实填写《XX出差费用报销单》，并列明事由、时间、路线、费用等项目后，交部门主管审核签字，再交公司财务人员审核签字，最后由分管副总审核签字，按实予以报销。</p>
              <p>报销单据须交部门经理审核签字，部门经理在每月13日之前交给财务人员，财务人员对票据进行审核确认无误后，然后由分管副总签字确认。</p>
              <p>分管副总签字完后，进行报销，在扣除员工个人借款后，将最终报销金额打入员工个人账户。</p>
              <p>所有项目费必须按自然月进行统计并报销，报销的费用不能超过3个月；所有费用报销务必附上报销明细表。</p>
            </div>
          </div>
          <div class="rules-foot" style="text-align:center">
            <Button  type="primary" size="large" @click="rulesModalOk" :disabled="countDown>0" v-if="entry_info.type!='审核通过'">确定已阅读 <span v-if="countDown>0">( {{countDown}} )</span></Button>
            <Button v-else type="text" size="large" @click="steps(step+1)">下一步</Button>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="step-panle" v-if="step==1">
          <div class="rules-head">
            <h1>员工信息登记表</h1>
          </div>
          <div class="rules-content">
            <div class="ivu-table ivu-table-border apps-entry-table">
              <div class="ivu-table-body">
                <Form ref="userResume" :model="userResume" :rules="ruleData" class="user-detail">
                  <h3 style="padding:20px 0">单位信息</h3>
                  <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%" class="pos-staic">
                    <tbody class="iv-table-tbody">
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">入职单位</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <FormItem prop="company_name" :rules="required">
                              <Select v-model="userResume.company_name">
                                <Option value="浙江宇脉科技股份有限公司"></Option>
                                <Option value="杭州领优信息科技有限公司">杭州领优信息科技有限公司</Option>
                              </Select>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">入职类型</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <FormItem prop="staff_type" :rules="required">
                              <Select v-model="userResume.staff_type">
                                <Option value="正式员工"></Option>
                                <Option value="实习生"></Option>
                                <Option value="非正式员工(自由人)"></Option>
                              </Select>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h3 style="padding:20px 0">个人信息</h3>
                  <table style="border:1px solid #e9eaec;border-collapse: collapse;">
                    <tbody class="iv-table-tbody">
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">中文姓名</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="name">
                              <Input v-model="userResume.name" placeholder="请输入真实姓名"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">英文姓名</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <Input v-model="userResume.ename" placeholder="请输入英文名"></Input>
                          </div>
                        </td>
                        <td rowspan="3" width="100" style="border:1px solid #e9eaec;text-align:center">
                          <div class="resume-avatar" style="position:relative;height:144px;left:0;top:0;background:#eee;overflow:hidden;">
                          <Upload
                              ref="upload"
                              :show-upload-list="false"
                              :default-file-list="defaultList"
                              :on-success="handleSuccess"
                              :format="['jpg','jpeg','png','gif']"
                              :max-size="2048"
                              :data="{file_type:'user_avatar'}"
                              :headers="uploadHeaders"
                              :on-format-error="handleFormatError"
                              :on-exceeded-size="handleMaxSize"
                              :before-upload="handleBeforeUpload"
                              v-show="entry_info.type!='审核通过'"
                              multiple
                              type="drag"
                              :action="uploadApiPath"
                               class="upload-item" style="width:114px;height:144px;margin:0">
                              <div class="upload-item-wrap" style="width:114px;height:144px;">
                                  <div class="upload-item-img" style="width:114px;height:144px;">
                                      <template v-if="userResume.avatar != ''">
                                          <img :src="getImage(userResume.avatar)" style="width:100%;height:100%">
                                      </template>
                                  </div>
                                  <div class="upload-item-cover" v-if="userResume.avatar == ''">
                                    请上传照片
                                  </div>
                              </div>
                            </Upload>
                            <div class="upload-item-wrap" v-show="getImage(userResume.avatar)!=null" style="width:114px;height:144px;position:absolute;top:0;left:0">
                                <div class="upload-item-img" style="width:114px;height:144px;">
                                    <template v-if="userResume.avatar != ''">
                                        <img :src="getImage(userResume.avatar)" style="width:100%;height:100%">
                                    </template>
                                </div>
                            </div>
                            <!-- <input class="avatar-file" id="avatarFile" type="file" accept="image/*" capture="video" @change="handleFileChange"/>
                            <label for="avatarFile" style="position:absolute;top:0;left:0;width:100%;z-index:2">
                              <img :src="userResume.avatar" if="userResume.avatar!=null" style="width:90px;height:134px;margin:5px;">
                              <canvas class="canvas-view" :width="100*4" :height="144*4" style="visible:hidden;width:0;height:0;" id="canvasView"></canvas>
                            </label>
                            <span style="position:absolute;top:50%;left:0;width:100%;z-index:1">请选择照片</span> -->
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">出生年月</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="birthday">
                              <Input v-model="userResume.birthday" placeholder="请输入您的生日"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">性别</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <Select v-model="userResume.gender">
                              <Option value="男" label="男"></Option>
                              <Option value="女" label="女"></Option>
                            </Select>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">政治面貌</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="political_status" :rules="required">
                              <Input v-model="userResume.political_status" placeholder="政治面貌"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">身高</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="height" :rules="required">
                              <Input v-model="userResume.height" placeholder="请输入身高"></Input>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">所学专业</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <!-- <FormItem prop="major" :rules="required"> -->
                              <Input v-model="userResume.major" placeholder="请输入专业"></Input>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">最高学历</div></th>
                        <td colspan="3">
                          <div class="ivu-table-cell">
                            <!-- <FormItem prop="education"> -->
                              <Select v-model="userResume.education">
                                <Option value="初中" label="初中"></Option>
                                <Option value="高中" label="高中"></Option>
                                <Option value="专科" label="专科"></Option>
                                <Option value="本科" label="本科"></Option>
                                <Option value="博士" label="博士"></Option>
                                <Option value="研究生" label="研究生"></Option>
                                <Option value="博士后" label="博士后"></Option>
                              </Select>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">籍贯</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="origin_place" :rules="required">
                              <Input v-model="userResume.origin_place" placeholder="请输入籍贯"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">户口所在地</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="reg_place" :rules="required">
                              <Input v-model="userResume.reg_place" placeholder="请输入户口所在地"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <td>
                          <div class="ivu-table-cell" style="overflow:visible">
                            <FormItem prop="reg_place" :rules="required">
                              <Select v-model="userResume.hkxz" placeholder="户口性质">
                                <Option value="本地农村">本地农村</Option>
                                <Option value="本地城镇">本地城镇</Option>
                                <Option value="外地农村">外地农村</Option>
                                <Option value="外地城镇">外地城镇</Option>
                              </Select>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">家庭地址</div></th>
                        <td colspan="5">
                          <div class="ivu-table-cell">
                            <FormItem prop="address" :rules="required">
                              <Input v-model="userResume.address" placeholder="请输入您的家庭地址"></Input>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">家庭电话</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="tel" :rules="required">
                              <Input v-model="userResume.tel" placeholder="请输入家庭电话"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">身份证</div></th>
                        <td colspan="3">
                          <div class="ivu-table-cell">
                            <FormItem prop="id_number" :rules="required">
                              <Input v-model="userResume.id_number" placeholder="请输入身份证、护照号"></Input>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">手机号码</div></th>
                        <td>
                          <div class="ivu-table-cell">
                            <FormItem prop="mobile">
                              <Input v-model="userResume.mobile" placeholder="请输入手机号码"></Input>
                            </FormItem>
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">邮箱地址</div></th>
                        <td colspan="3">
                          <div class="ivu-table-cell">
                            <FormItem prop="email">
                              <Input v-model="userResume.email" placeholder="请输入邮箱地址"></Input>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">婚姻状况</div></th>
                        <td colspan="5">
                          <div class="ivu-table-cell">
                            <FormItem prop="marital_status" :rules="required">
                              <RadioGroup v-model="userResume.marital_status">
                                <Radio value="未婚" label="未婚"></Radio>
                                <Radio value="已婚" label="已婚"></Radio>
                                <Radio value="离婚" label="离婚"></Radio>
                              </RadioGroup>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">学习经历</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="width:130px"><div class="ivu-table-cell">时间</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell"></div></th>
                                  <th style="text-align:center;width:120px"><div class="ivu-table-cell">学历</div></th>
                                  <th style="text-align:center;width:120px"><div class="ivu-table-cell">专业</div></th>
                                  <th style="width:40px"></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in userResume.edu_exp" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <FormItem :prop="'edu_exp.' + index + '.time'" :rules="required">
                                        <Input v-model="item.time" placeholder="如:2017.7--2018.1"></Input>
                                      </FormItem>
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <FormItem :prop="'edu_exp.' + index + '.con'" :rules="required">
                                        <Input v-model="item.con" placeholder="学校、培训机构"></Input>
                                      </FormItem>
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <FormItem :prop="'edu_exp.' + index + '.edu'" :rules="required">
                                        <Input v-model="item.edu" placeholder="学历"></Input>
                                      </FormItem>
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <FormItem :prop="'edu_exp.' + index + '.major'" :rules="required">
                                        <Input v-model="item.major" placeholder="专业"></Input>
                                      </FormItem>
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <Button size="small" v-if="index>0" @click="removeItem(userResume.edu_exp, index)">
                                      <Icon type="minus-round"></Icon>
                                    </Button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5" style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <Button type="default" size="small" @click="addItem('edu_exp')">
                                        <Icon type="plus-round"></Icon> 增加一项
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">工作经历</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <table style="width:100%;border-collapse: collapse;">
                            <tbody>
                              <tr class="ivu-table-row">
                                <th style="text-align:center;width:130px"><div class="ivu-table-cell">时间</div></th>
                                <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                <th style="text-align:center;width:120px"><div class="ivu-table-cell">职务</div></th>
                                <th style="text-align:center;width:120px"><div class="ivu-table-cell">离职原因</div></th>
                                <th style="width:40px"></th>
                              </tr>
                            </tbody>
                            <tbody v-for="(item, index) in userResume.work_exp" :key="index">
                                <tr class="ivu-table-row">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <!-- <FormItem :prop="'work_exp.' + index + '.time'" :rules="required"> -->
                                        <Input v-model="item.time" placeholder="如:2017.7--2018.1"></Input>
                                      <!-- </FormItem> -->
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <!-- <FormItem :prop="'work_exp.' + index + '.unit'" :rules="required"> -->
                                        <Input v-model="item.unit" placeholder="工作单位"></Input>
                                      <!-- </FormItem> -->
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <!-- <FormItem :prop="'work_exp.' + index + '.post'" :rules="required"> -->
                                        <Input v-model="item.post" placeholder="职位"></Input>
                                      <!-- </FormItem> -->
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      <!-- <FormItem :prop="'work_exp.' + index + '.reason'" :rules="required"> -->
                                        <Input v-model="item.reason" placeholder="离职原因"></Input>
                                      <!-- </FormItem> -->
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <Button size="small" v-if="index>0" @click="removeItem(userResume.work_exp, index)">
                                      <Icon type="minus-round"></Icon>
                                    </Button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <div class="ivu-table-cell" style="padding:5px;">
                                      <Input type="textarea" v-model="item.detail" placeholder="项目经历"></Input>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                              <tr>
                                <td colspan="5" style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <Button type="default" size="small" @click="addItem('work_exp')">
                                      <Icon type="plus-round"></Icon> 增加一项
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">特殊技能</div></th>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">获得的证书情况</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <table style="width:100%;border-collapse: collapse;">
                            <tbody>
                              <tr class="ivu-table-row">
                                <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书名称</div></th>
                                <th style="text-align:center;width:130px"><div class="ivu-table-cell">获得时间</div></th>
                                <th style="text-align:center;width:auto"><div class="ivu-table-cell">颁发单位</div></th>
                                <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书是否在公司备案</div></th>
                                <th style="width:40px"></th>
                              </tr>
                              <tr class="ivu-table-row" v-for="(item, index) in userResume.certificate" :key="index">
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <!-- <FormItem :prop="'certificate.' + index + '.name'" :rules="required"> -->
                                      <Input v-model="item.name" placeholder="证书名称"></Input>
                                    <!-- </FormItem> -->
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <!-- <FormItem :prop="'certificate.' + index + '.time'" :rules="required"> -->
                                      <Input v-model="item.time" placeholder="获得时间"></Input>
                                    <!-- </FormItem> -->
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <!-- <FormItem :prop="'certificate.' + index + '.unit'" :rules="required"> -->
                                      <Input v-model="item.unit" placeholder="颁发单位"></Input>
                                    <!-- </FormItem> -->
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <RadioGroup v-model="item.redord">
                                      <Radio value="是" label="是"></Radio>
                                      <Radio value="否" label="否"></Radio>
                                    </RadioGroup>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <Button size="small" v-if="index>0" @click="removeItem(userResume.certificate, index)">
                                    <Icon type="minus-round"></Icon>
                                  </Button>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="5" style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <Button type="default" size="small" @click="addItem('certificate')">
                                      <Icon type="plus-round"></Icon> 增加一项
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">紧急情况联系人</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <table style="width:100%;border-collapse: collapse;">
                            <tbody>
                              <tr class="ivu-table-row">
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                <th style="text-align:center;width:auto"><div class="ivu-table-cell">联系地址</div></th>
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">私人邮箱</div></th>
                                <th style="width:40px"></th>
                              </tr>
                              <tr class="ivu-table-row" v-for="(item, index) in userResume.content" :key="index">
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'content.' + index + '.name'" :rules="required">
                                      <Input v-model="item.name" placeholder="联系人姓名"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'content.' + index + '.relation'" :rules="required">
                                      <Input v-model="item.relation" placeholder="关系"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'content.' + index + '.address'" :rules="required">
                                      <Input v-model="item.address" placeholder="联系地址"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'content.' + index + '.tel'" :rules="required">
                                      <Input v-model="item.tel" placeholder="联系电话"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                      <Input v-model="item.email" placeholder="邮箱"></Input>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <Button size="small" v-if="index>0" @click="removeItem(userResume.content, index)">
                                    <Icon type="minus-round"></Icon>
                                  </Button>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="6" style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <Button type="default" size="small" @click="addItem('content')">
                                      <Icon type="plus-round"></Icon> 增加一项
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell">家庭成员</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <table style="width:100%;border-collapse: collapse;">
                            <tbody>
                              <tr class="ivu-table-row">
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                <th style="width:40px"></th>
                              </tr>
                              <tr class="ivu-table-row" v-for="(item, index) in userResume.family" :key="index">
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'family.' + index + '.name'" :rules="required">
                                      <Input v-model="item.name" placeholder="姓名"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'family.' + index + '.relation'" :rules="required">
                                      <Input v-model="item.relation" placeholder="关系"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'family.' + index + '.tel'" :rules="required">
                                      <Input v-model="item.tel" placeholder="联系电话"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <FormItem :prop="'family.' + index + '.unit'" :rules="required">
                                      <Input v-model="item.unit" placeholder="工作单位"></Input>
                                    </FormItem>
                                  </div>
                                </td>
                                <td style="text-align:center">
                                  <Button size="small" v-if="index>0" @click="removeItem(userResume.family, index)">
                                    <Icon type="minus-round"></Icon>
                                  </Button>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="5" style="text-align:center">
                                  <div class="ivu-table-cell">
                                    <Button type="default" size="small" @click="addItem('family')">
                                      <Icon type="plus-round"></Icon> 增加一项
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th colspan="6" style="text-align:center"><div class="ivu-table-cell"> 备注</div></th>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <div class="ivu-table-cell" style="padding:8px">
                            <FormItem prop="remarks" :rules="required">
                              <Input type="textarea" v-model="userResume.remarks" placeholder="对将来的职业期望，努力方向"></Input>
                            </FormItem>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h3 style="padding:20px 0">银行信息 <small>关系到工资发放，请认真填写</small></h3>
                  <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%">
                    <tbody class="iv-table-tbody">
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">开户姓名</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <!-- <FormItem prop="remarks" :rules="required"> -->
                              <Input v-model="userResume.bank.name" placeholder="请输入您的开户名"></Input>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">开户行</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <!-- <FormItem prop="remarks" :rules="required"> -->
                              <Input v-model="userResume.bank.bank_name" placeholder="请输入您的开户行"></Input>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">银行行号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <!-- <FormItem prop="remarks" :rules="required"> -->
                              <Input v-model="userResume.bank.number" style="width:200px;" placeholder="请输入您的银行行号" :maxlength="14"></Input>
                              <a href="http://www.5cm.cn/bank" target="_black" style="color:#2d8cf0">行号在线查询</a>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">银行卡号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                            <!-- <FormItem prop="remarks" :rules="required"> -->
                              <Input v-model="userResume.bank.card_number" placeholder="请输入您的银行卡号"></Input>
                            <!-- </FormItem> -->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br/>
                  <Alert type="warning">
                    <h4>提示:</h4>
                    银行行号为12位数字<br/>
                    开户行示例：<Tag>招商银行 南京分行城北支行</Tag>
                  </Alert>
                </Form>
              </div>
            </div>
          </div>
          <div class="rules-foot" style="text-align:center">
            <Button type="text" size="large" @click="step = step-1">上一步</Button>
            <Button type="primary" size="large" @click="submitResume('userResume')" :disabled="submitDis" v-if="entry_info.type!='审核通过'">{{userResume.id==0?'提交资料':'修改资料'}}</Button>
            <Button type="text" size="large" @click="step = step+1" :disabled="steping<2||userResume.id==0">下一步</Button>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="step-panle" v-if="step==2">
          <div class="rules-head">
            <h1 style="text-align:left">上传资料</h1>
          </div>
          <div class="rules-content">
            <h4>身份证</h4>
            <div class="upload-box">
                <Upload
                    ref="passCardUpload"
                    :show-upload-list="false"
                    :default-file-list="uploadList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :data="{file_type:'id_card_f'}"
                    :headers="uploadHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadApiPath"
                     class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img">
                            <template v-if="uploads.id_card_f != null">
                                <img :src="uploads.id_card_f" style="height:100%">
                            </template>
                        </div>
                        <div class="upload-item-cover" v-if="uploads.id_card_f == null">
                          <Icon type="card" size="40"></Icon>
                          身份证正面
                        </div>
                    </div>
                </Upload>
                <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :data="{file_type:'id_card_b'}"
                    :headers="uploadHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    multiple
                    type="drag"
                    :action="uploadApiPath"
                     class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img">
                            <template v-if="uploads.id_card_b != null">
                                <img :src="uploads.id_card_b" style="height:100%">
                            </template>
                        </div>
                        <div class="upload-item-cover" v-if="uploads.id_card_b == null">
                          <Icon type="card" size="40"></Icon>
                          身份证背面
                        </div>
                    </div>
                </Upload>
            </div>
            <h4>学历证</h4>
            <div class="upload-box">
              <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :data="{file_type:'education_certificate'}"
                    :headers="uploadHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    multiple
                    type="drag"
                    :action="uploadApiPath"
                     class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img">
                            <template v-if="uploads.education_certificate != null">
                                <img :src="uploads.education_certificate" style="height:100%">
                            </template>
                        </div>
                        <div class="upload-item-cover" v-if="uploads.education_certificate == null">
                          <Icon type="university" size="40"></Icon>
                          学历证
                        </div>
                    </div>
                </Upload>
            </div>
            <h4>学位证</h4>
            <div class="upload-box">
              <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :data="{file_type:'degree_certificate'}"
                  :headers="uploadHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :action="uploadApiPath"
                   class="upload-item">
                  <div class="upload-item-wrap">
                      <div class="upload-item-img">
                          <template v-if="uploads.degree_certificate != null">
                              <img :src="uploads.degree_certificate" style="height:100%">
                          </template>
                      </div>
                      <div class="upload-item-cover" v-if="uploads.degree_certificate == null">
                        <Icon type="ribbon-b" size="40"></Icon>
                        学位证
                      </div>
                  </div>
              </Upload>
            </div>
          </div>
          <div class="rules-foot" style="text-align:center">
            <Button type="text" size="large" @click="step=step-1">上一步</Button>
            <Button type="primary" size="large" @click="submitContract" v-if="this.entry_status===0">提交审核</Button>
            <Button type="text" size="large" @click="steps(step+1)" :disabled="isUpload()">下一步</Button>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="step-panle" v-if="step==4">
          <div class="rules-head">
            <h1 style="text-align:left">下载合同 </h1>
          </div>
          <div class="rules-content contract-down">
            <div style="font-size:16px;">
              <p>合同一式{{userResume.staff_type=='实习生'?'二':'三'}}份，空白打印出来后再签字。</p>
              <p>请先填写好乙方的基本信息及最后您的签名，</p>
              <p>凡是涉及到时间的都不要填写，空白事项公司会填写上。</p>
            </div>
            <h4 style="text-align:left">合同模板</h4>
            <template v-for="(item, ind) in contracts">
              <a :href="formatPath(item.path)" :key="ind" v-if="userResume.company_name == item.company && userResume.staff_type==item.type" target="_black" class="contract-item"><Icon type="ios-cloud-download-outline"></Icon> {{item.name}}</a>
            </template>
            <h4 style="text-align:left">公司邮寄地址</h4>
            <div style="text-align:left;border:1px solid #ccc;background:#f1f1f1;padding:15px;border-radius:4px;">
              <p>潘子权</p>
              <p>浙江宇脉科技股份有限公司（股票代码：837977）</p>
              <p>地址：浙江省杭州市下城区沈家路150号 互联网影视产业园区1幢305</p>
              <p>联系电话：18069820937    Email：hr@zjyumai.com</p>
            </div>
          </div>
          <div class="rules-foot" style="text-align:center">
            <Button type="text" size="large" @click="step=step-1">上一步</Button>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="step-panle" v-if="step==3">
          <div class="rules-head">
            <h1 style="text-align:left">完成</h1>
          </div>
          <div class="rules-content" style="text-align:center;padding:60px 0 100px">
            <h2>{{entry_info.type=='审核通过'?'恭喜您，资料审核通过成功！':'恭喜您，您已完成入职资料提交！'}}</h2>
            <div style="color:#999">
              <p>&nbsp;</p>
              <template v-if="entry_info!=null&&entry_info!=''">
                  <Alert type="success" show-icon v-if="entry_info.type=='审核通过'" style="display:inline-block;text-align:left;">
                    <p>状态：{{entry_info.type}}</p>
                    <p>描述：{{entry_info.remarks}}</p>
                  </Alert>
                  <Alert type="warning" show-icon v-if="entry_info.type=='信息错误'" style="display:inline-block;text-align:left;">
                    <p>状态：{{entry_info.type}}</p>
                    <p>描述：{{entry_info.remarks}}</p>
                  </Alert>
              </template>
              <template v-else-if="this.uploads.id_card_f && this.uploads.id_card_b">
                <Tag color="yellow">审核中，请稍等...</Tag>
              </template>
              <template v-else>
                <Tag color="red">请上传身份证信息</Tag>
              </template>
              <p>&nbsp;</p>
              <p>请等待审核！如需修改可点'上一步'查看</p>
              <p>或</p>
              <p>拨打 0571-56920695，了解审核情况</p>
              <p>公司群号：35505275</p>
              <p>欢迎您的加入！加入时请写明姓名、项目地及招录人，谢谢！</p>
            </div>
          </div>
           <div class="rules-foot" style="text-align:center">
            <Button type="text" size="large" @click="step=step-1">上一步</Button>
            <Button type="text" size="large" @click="steps(step+1)" :disabled="steping<3">下一步</Button>
            <!-- <Button type="primary" size="large" @click="submitToExamine()">提交审核</Button> -->
          </div>
        </div>
      </transition>
    </div>
    <Modal
        v-model="rulesModal"
        title="浙江宇脉科技股份有限公司-规章制度"
        width="90%"
        class="rules-modal"
        :styles="{marginBottom:'40px',position:'fixed'}">
        <footer slot="footer">
        </footer>
    </Modal>
  </section>
</template>

<script>
  import {fetch, put, post} from '../fetch/api'
  import validate from '../util/validateForm'
  const baseDate = {
    edu_exp: {time: '', con: '', edu: '', major: ''},
    work_exp: {time: '', unit: '', post: '', reason: '', detail: ''},
    certificate: {name: '', time: '', unit: '', redord: '是'},
    content: {name: '', relation: '', address: '', tel: '', email: ''},
    family: {name: '', relation: '', tel: '', unit: ''}
  }
  const resumeData = {
    id: 0,
    name: '',
    ename: '',
    birthday: '',
    gender: '',
    company_name: '浙江宇脉科技股份有限公司',
    staff_type: '正式员工',
    avatar: null,
    political_status: '',
    height: '',
    major: '',
    education: '',
    origin_place: '',
    reg_place: '',
    address: '',
    tel: '',
    email: '',
    hkxz: '',
    mobile: '',
    id_number: '',
    marital_status: '',
    edu_exp: [baseDate.edu_exp],
    work_exp: [baseDate.work_exp],
    bank: {
      name: '',
      card_number: '',
      number: '',
      bank_name: ''
    },
    certificate: [baseDate.certificate],
    content: [baseDate.content],
    family: [baseDate.family],
    remarks: ''
  }

  export default {
    name: 'EntryPage',
    components: {
      // ContractCom: resolve => { require(['../components/ContractComponent'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      const checkPhone = (rule, value, callback) => {
        let res = validate.phone(value)
        if (res !== true) {
          callback(new Error(res))
        } else {
          callback()
        }
      }
      return {
        autoSaveFlag: null,
        entry_info: '',
        uploadApiPath: '/api/users/upfile',
        defaultList: [
          {
            'name': 'a42bdcc1178e62b4694c830f028db5c0',
            'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
          }
        ],
        contracts: [
          {name: '宇脉科技劳动合同.pdf', type: '正式员工', company: '浙江宇脉科技股份有限公司', path: './contract/宇脉科技劳动合同.pdf'},
          {name: '非全日制劳动合同.pdf', type: '非正式员工(自由人)', company: '浙江宇脉科技股份有限公司', path: './contract/非全日制劳动合同最新-宇脉.pdf'},
          {name: '杭州领优信息科技有限公司-非全日合同.pdf', type: '非正式员工(自由人)', company: '杭州领优信息科技有限公司', path: './contract/杭州领优信息科技有限公司-非全日合同.pdf'},
          {name: '领优劳动合同.pdf', type: '正式员工', company: '杭州领优信息科技有限公司', path: './contract/领优劳动合同.pdf'},
          {name: '领优实习协议书.pdf', type: '实习生', company: '杭州领优信息科技有限公司', path: './contract/领优实习协议书.pdf'},
          {name: '宇脉实习协议模板.pdf', type: '实习生', company: '浙江宇脉科技股份有限公司', path: './contract/宇脉实习协议模板.pdf'}
        ],
        token: token,
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        userResumeAvatar: null,
        userResume: JSON.parse(JSON.stringify(resumeData)),
        uploads: {
          id_card_f: null,
          id_card_b: null,
          education_certificate: null,
          degree_certificate: null
        },
        submitDis: false,
        maxSize: 500,
        uploadList: [],
        rulesModal: false,
        rulesIsRead: false,
        countDown: 60,
        countDownFlag: null,
        step: 0,
        steping: 0,
        required: {required: true, message: '请输入', trigger: 'blur'},
        entry_status: 0,
        ruleData: {
          birthday: [
            {required: true, message: '请输入出生日期', trigger: 'blur'}
          ],
          mobile: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {validator: checkPhone, trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'change'},
            { type: 'email', message: '邮箱地址格式错误', trigger: 'blur' }
          ],
          password: [
            {required: true, min: 6, message: '请输入密码，必须大于6个字符！', trigger: 'blur'}
          ]
        }
      }
    },
    mounted () {
      const step = localStorage.getItem('rulesReadState') ? Number(localStorage.getItem('rulesReadState')) : 0
      this.steping = step
      this.step = step
      if (this.step === 0) {
        this.startReadRules()
      } else {
        this.countDown = 0
      }
      this.fetchEntryInfo()

      // let resume = localStorage.getItem('userResume')
      // if (resume != null) {
      //   resume = JSON.parse(resume)
      //   if (resume.user_id === this.$store.state.userInfo.id || this.$store.state.userInfo.id === 0) {
      //     this.userResume = resume
      //   } else {
      //     localStorage.removeItem('userResume')
      //   }
      // }
      // this.autoSaveFlag = setInterval(() => {
      //   localStorage.setItem('userResume', JSON.stringify(this.userResume))
      // }, 3000)
    },
    destroyed () {
      clearInterval(this.autoSaveFlag)
    },
    methods: {
      fetchEntryInfo () {
        // localStorage.removeItem('rulesReadState')
        let uid = this.$store.state.userInfo.id
        fetch(`/users/entry/info/${uid}`).then(res => {
          if (res.status === 'ok') {
            this.entry_status = res.entry_status
            let data = res.resume
            if (data !== null) {
              data['edu_exp'] = JSON.parse(data['edu_exp'])
              data['work_exp'] = JSON.parse(data['work_exp'])
              // data['special_skill'] = JSON.parse(data['special_skill'])
              data['certificate'] = JSON.parse(data['certificate'])
              data['content'] = JSON.parse(data['content'])
              data['family'] = JSON.parse(data['family'])
              data['bank'] = (data['bank'] === null || data['bank'] === '') ? {} : JSON.parse(data['bank'])
              this.userResume = data
              this.steps(1)

              if (res.files.length > 0) {
                for (let k in res.files) {
                  let _file = res.files[k]
                  if (_file.file_type === 'id_card_f') this.uploads.id_card_f = this.getImage(_file.file_path)
                  if (_file.file_type === 'id_card_b') this.uploads.id_card_b = this.getImage(_file.file_path)
                  if (_file.file_type === 'education_certificate') this.uploads.education_certificate = this.getImage(_file.file_path)
                  if (_file.file_type === 'degree_certificate') this.uploads.degree_certificate = this.getImage(_file.file_path)
                }
                this.steps(2)
              }
              if (this.isUpload() && data !== null) {
                this.steps(3)
              }
              if (res.entry_info !== null) {
                this.entry_info = res.entry_info
              }
              if (this.entry_status === 1) {
                this.steps(3)
              }
              if (this.entry_info.type === '审核通过') {
                this.steps(4)
              }
            } else {
              this.steps(1)
            }
          }
        })
      },
      submitToExamine () {
        put('/console/entryStatus/1')
        // .then(res => {
        //   if (res.status === 'ok') {
        //   }
        // })
        this.steps(3)
      },
      formatPath (path) {
        return `${this.apiPath}/api/console/pdf?type=pdf&path=${path}&token=${this.token}`
      },
      isUpload () {
        return this.uploads.id_card_f === null || this.uploads.id_card_b === null
      },
      getImage (path) {
        return path ? `/api/console/file?path=${path}&token=${this.token}` : null
      },
      handleView (name) {
        this.imgName = name
        this.visible = true
      },
      handleRemove (file) {
        const fileList = this.$refs.passCardUpload.fileList
        this.$refs.passCardUpload.fileList.splice(fileList.indexOf(file), 1)
      },
      /**
        * id_card_f：身份证正面
        * id_card_b：身份证反面
        * education_certificate：学历证
        * degree_certificate：学位证
        **/
      handleSuccess (res) {
        let fileType = res.result.file_type
        let path = `/api/console/file?path=${res.result.file_path}&token=${this.token}`
        if (fileType === 'user_avatar') {
          this.userResume.avatar = res.result.file_path
        } else {
          this.uploads[fileType] = path
        }
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          })
        }
        return check
      },
      startReadRules () {
        this.countDown = 10
        this.countDownFlag = setInterval(() => {
          this.countDown --
          if (this.countDown === 0) {
            clearInterval(this.countDownFlag)
          }
        }, 1000)
      },
      rulesModalOk () {
        this.rulesModal = false
        this.rulesIsRead = true
        this.steps(1)
      },
      submitResume (name) {
        this.submitDis = true
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.userResume))
            let res
            // data['bank'] = data['bank'] === {} ? {} : JSON.stringify(data['bank'])
            if (data.id === 0 || data.user_id !== this.$store.state.userInfo.id) {
              res = post(`/users/resume`, data)
            } else {
              res = put(`/users/resume`, data)
            }
            res.then(res => {
              if (res.status === 'ok') {
                this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
                // this.userResume = JSON.parse(JSON.stringify(formData))
                // this.fetchData()
                this.fetchEntryInfo()
                this.steps(2)
                // clearInterval(this.autoSaveFlag)
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
        setTimeout(() => {
          this.submitDis = false
        }, 10000)
      },
      steps (ind) {
        this.step = ind
        if (this.step > this.steping) {
          this.steping = ind
          localStorage.setItem('rulesReadState', ind)
        }
      },
      handleFileChange (e) {
        if (typeof e.target === 'undefined') {
          this.file = e[0]
        } else {
          this.file = e.target.files[0]
        }
        let size = Math.floor(this.file.size / 1024)
        if (size > this.maxSize) {
          this.$Message.error(`文件大小不能超过${this.maxSize}KB`)
          return false
        }
        this.previewImage(this.file)
      },
      submitContract () {
        // let dom = document.getElementById('contractHtml')
        // let html = dom.innerHTML
        // let data = {
        //   'user_id': 0,
        //   'sign_info': JSON.stringify(this.contractData)
        // }
        // if (this.contractData.name === '') this.$Message.error('请输入乙方姓名')
        // if (this.contractData.birthday === '') this.$Message.error('请输入乙方出生日期')
        // if (this.contractData.gender === '') this.$Message.error('请输入乙方性别')
        // if (this.contractData.phone === '') this.$Message.error('请输入乙方联系电话')
        // if (this.contractData.id_number === '') this.$Message.error('请输入乙方身份证号码')
        // if (this.contractData.job_name === '') this.$Message.error('请输入您从事的工作')
        // if (this.contractData.signature === null) this.$Message.error('请您签名')
        // if (this.contractData.sign_year === '') this.$Message.error('请输入签约日期')
        // if (this.contractData.sign_month === '') this.$Message.error('请输入签约日期')
        // if (this.contractData.sign_day === '') this.$Message.error('请输入签约日期')

        // post('/users/contract', data).then(res => {
        //   if (res.status === 'ok') {
        //     this.steps(4)
        //   }
        // })

        if (this.uploads.id_card_f === null || this.uploads.id_card_f === '') {
          this.$Message.success('请上传身份证正面照片')
          return false
        }
        if (this.uploads.id_card_b === null || this.uploads.id_card_f === '') {
          this.$Message.success('请上传身份证反面照片')
          return false
        }
        this.submitToExamine()
      },
      previewImage (file) {
        let _this = this
        _this.isSubmit = false
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return
        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader()
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onload = function () {
            let img = new Image()
            img.onload = function () {
              let $canvas = document.getElementById('canvasView')
              let $ctx = $canvas.getContext('2d')
              let w = 100 * 4
              let h = 144 * 4
              $ctx.clearRect(0, 0, w, h)
              $ctx.drawImage(img, 0, 0, w, h)

              _this.userResume.avatar = $canvas.toDataURL()
            }
            img.src = this.result
          }
        }
      },
      addItem (name) {
        const item = JSON.parse(JSON.stringify(baseDate[name]))
        this.userResume[name].push(item)
      },
      removeItem (item, index) {
        item.splice(item.indexOf(item[index]), true)
      },
      goToStep (step) {
        this.step = step
      }
    }
  }
</script>
<style>
  .apps-entry-table .ivu-table-cell{padding:0 6px;}
  .apps-entry-table:after{display: none;}
  .apps-entry-table .ivu-form-item{margin:0 auto;}
  .apps-entry-table .ivu-form-item-error-tip{top:5px;right:5px;left:auto;}
  .apps-entry-table.ivu-table:before{display: none;}
  .apps-entry-table th{width:80px;text-align: right}
  .apps-entry-steps.ivu-steps .ivu-steps-head,
  .apps-entry-steps.ivu-steps .ivu-steps-title{background: none;}
  .pos-staic .ivu-form-item-content{position: static;}
</style>
<style scoped>
  .avatar-file{display: none}
  .apps-entry-steps{width:180px;float:left;padding-top:20px;}
  .apps-entry{
    width: 1030px;
    height: 100%;
    margin: 40px auto 0;

  }
  .apps-entry-content{
    margin-left: 190px;
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    min-height: 400px;
    margin-bottom: 40px;
    position: relative;
  }
  .apps-entry-title{
    margin-bottom: 10px;
  }
  .apps-entry-steps-buttons{
    padding: 5px 34px;
  }
  .rules-head{
    border-bottom: 1px solid #eee;
    padding:20px 20px 10px;
  }
  .rules-foot{
    width: 100%;
    padding: 20px 0;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
  }
  .rules-content{
    padding: 10px 20px 100px;
    border-width: 1px 0;
  }
  .rules-content h4{margin:10px 0;color:#666;}
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .upload-box{margin-bottom: 20px;}
  .upload-item{
    width:256px;
    display: inline-block;
    margin-left: 15px;
  }
  .upload-item-wrap{
    width: 256px;
    height: 160px;
    overflow: hidden;
    background-color: #f7f7f7
  }
  .upload-item-img,
  .upload-item-img img{height: 100%}
  .upload-item-cover{
    width: 100%;
    font-size:18px;
    color:#999;
    line-height: 40px;
    position: absolute;
    top: 60px;
  }
  .upload-item-cover i{vertical-align: middle;color:#999;}
  .contract-down{padding-top:20px;text-align: center}
  .contract-item{width:140px;display:inline-block;text-align: center;vertical-align: top;margin:0 10px;}
  .contract-item .ivu-icon{
    width: 140px;
    padding: 20px 0;
    font-size: 60px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center;
    background-color: #f1f1f1;
    margin-bottom: 10px;
  }
  .rules-book p{
    text-indent: 2em;
    color: #666;
    line-height: 2
  }
</style>
